module.exports = "/static/assets/e8ef67af25daf4a598bfbda69d79cd27.png";